/**
 * Costanti + types condivisi tra le varianti di design della lista escursioni.
 */

export interface ExcursionItem {
  id: string;
  slug: string;
  title: string;
  description: string | null;
  category: string | null;
  duration_minutes: number;
  max_capacity: number;
  /** Posti prenotabili (ospiti). null → fallback a max_capacity. */
  max_guests?: number | null;
  meeting_point: string | null;
  meeting_lat?: number | null;
  meeting_lng?: number | null;
  price: number | string;
  pricing_mode: string;
  pricing_tiers?: Array<{ persons: number; price: number | string; label?: string; exclusive?: boolean }> | null;
  hero_image: string | null;
  difficulty: string | null;
  is_premium?: boolean;
  /** Prenotazioni confermate (vetrina home mode='most_booked'). */
  booking_count_all?: number;
  booking_count_90d?: number;
  booking_count_30d?: number;
  included?: string[] | null;
  last_minute_enabled?: boolean | null;
  last_minute_days_before?: number | null;
  last_minute_discount_percent?: number | null;
  owner?: { id: string; name: string; company_name?: string | null };
  /** Prossima partenza prenotabile (data ISO + ora HH:MM + posti residui) dai periodi stagionali. */
  next_departure?: { date: string; time: string; seats?: number | null } | null;
  /** Periodi stagionali (raw) per il filtro disponibilità per data (client-side). */
  seasonal_periods?: unknown;
  /** Aggregato recensioni (denormalizzato su excursions). */
  rating?: number | null;
  reviews_count?: number | null;
  /** P1.1 card ricche. */
  languages?: string[] | null;
  cancellation_name?: string | null;
  /** true SOLO in modalità "Anteprima bozze" ADMIN — item DRAFT mostrato come pubblicato. */
  is_draft?: boolean;
  /** Porto EFFETTIVO (Step 9b): meeting_poi_id esplicito, fallback boat.port_id. null = ritrovo libero. */
  port_id?: string | null;
  port_name?: string | null;
  port_city?: string | null;
  port_zone?: string | null;
}

// Allineata tassonomia 4+4 (2026-06-04). Legacy mantenuti come safety.
export const CATEGORY_LABEL: Record<string, string> = {
  // 4 escursione
  pescaturismo:      'Pescaturismo',
  'tour-barca':      'Tour in barca',
  snorkeling:        'Snorkeling & Diving',
  'sport-acquatici': 'Sport acquatici',
  // 4 esperienza
  'sunset-cruise':   'Aperitivo al tramonto',
  'chef-on-board':   'Chef a bordo',
  'festa-privata':   'Festa privata',
  wellness:          'Wellness & Relax',
  // Legacy safety
  'grotte-marine':   'Tour grotte marine',
  'tour-isole':      'Island hopping',
  'pesca-sportiva':  'Pesca sportiva',
  'eventi-privati':  'Eventi privati',
  'charter-custom':  'Charter su misura',
};

export function durationLabel(min: number): string {
  if (!min) return '—';
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const r = min % 60;
  return r === 0 ? `${h}h` : `${h}h ${r}m`;
}

export type DesignVariant = 'v1' | 'v2' | 'premium' | 'v3';
